<div class="d-flex flex-wrap">
  @for (legend of legendChoose; track legend; let last = $last) {
    <div
      [ngClass]="{'mr-3': !last}"
      class="text-tertiary font-size-small d-inline-flex flex-nowrap align-items-center">
      <i class="fas fa-square mr-2" [ngStyle]="{color: legend.color}"></i>{{legend.name | translate}}
    </div>
  }
</div>

